import React, { useCallback } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../theme';
import { getTravellerName } from '../../utils';
import { WarningRounded } from '../../Icons';
import { Field, Form } from 'react-final-form';
import { ModalX, BaseButton, Input } from '../../BaseComponents';
import { IINFieldKeyFactory } from '../utils';
const InsuranceModalConfirmINN = ({ className, passengers, isOpen, onClose, isSubmitLoading, onSubmit }) => {
    const { t } = useTranslation('InsuranceModalConfirmINN');
    const theme = useTheme('InsuranceModalConfirmINN').InsuranceModalConfirmINN;
    const validate = useCallback((value) => {
        if (!value) {
            return t('Required');
        }
        else if (value.length < 12) {
            return t('Enter 12 digits');
        }
        return undefined;
    }, []);
    return (React.createElement(ModalX, { isOpen: isOpen, onClose: onClose, title: t('Enter your IIN for insurance'), size: "large", classes: { paper: cn(theme.modal, className), closeButton: theme.closeButton, title: theme.title } },
        React.createElement("h3", { className: theme.subtitle }, t('In order to activate the insurance policy it is necessary to specify the IIN of each passenger. This is necessary to apply for and receive payment in case of accidents covered by the insurance.')),
        React.createElement(Form, { onSubmit: onSubmit, render: ({ handleSubmit, submitErrors }) => (React.createElement("form", { onSubmit: handleSubmit, className: theme.passengers },
                passengers.map(passenger => (React.createElement("div", { className: theme.passenger, key: passenger.id },
                    React.createElement("div", { className: theme.passenger__name }, getTravellerName(passenger)),
                    React.createElement(Field, { name: IINFieldKeyFactory(passenger.id), validate: validate, render: ({ input, meta }) => (React.createElement(Input, Object.assign({}, input, { className: theme.passenger__input, placeholder: t('Passenger IIN'), label: t('Passenger IIN'), error: (meta.error && meta.touched) ||
                                (!meta.dirtySinceLastSubmit && !!submitErrors), helperText: (!!meta.error && meta.touched && meta.error) ||
                                (!meta.dirtySinceLastSubmit && t(submitErrors)), inputProps: {
                                maxLength: 12
                            } }))) })))),
                React.createElement("p", { className: theme.info },
                    React.createElement("span", { className: theme.info__icon }, WarningRounded),
                    t('IIN is an Individual Identification Number that consists of 12 numbers')),
                React.createElement("div", { className: theme.controls },
                    React.createElement(BaseButton, { onClick: onClose, variant: "smallSecondary", className: theme.controls__cancel }, t('Cancel')),
                    React.createElement(BaseButton, { type: "submit", variant: "smallPrimary", className: theme.controls__continue, isLoading: isSubmitLoading }, t('Continue'))))) })));
};
export default InsuranceModalConfirmINN;
